import { render } from "./ModalEnterOtp.vue?vue&type=template&id=7ebc635e&scoped=true"
import script from "./ModalEnterOtp.vue?vue&type=script&lang=js"
export * from "./ModalEnterOtp.vue?vue&type=script&lang=js"

import "./ModalEnterOtp.vue?vue&type=style&index=0&id=7ebc635e&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ebc635e"]])

export default __exports__